import { useQuery } from '@tanstack/react-query';
import { activityApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

/**
 * Hook to fetch a single activity by ID
 * @param id - Activity ID
 * @returns React Query result with activity data
 */
export function useActivity(id: string) {
  return useQuery({
    queryKey: queryKeys.activities.detail(id),
    queryFn: () => activityApi.getActivity(id),
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    retry: 1, // Only retry once for 404s
  });
}
